var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpnGreyLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 170,
    height: 80,
    viewBox: "0 0 170 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16082",
    "data-name": "Rectangle 16082",
    width: 170,
    height: 80,
    transform: "translate(8551 -1945)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SPN-grey-logo",
    transform: "translate(-8551 1945)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48421",
    "data-name": "Group 48421",
    transform: "translate(8525.988 -1938.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72886",
    "data-name": "Path 72886",
    d: "M581.359,587.231c-.206-5-3.973-7.493-9.376-7.493-3.324,0-8.031,1.4-8.031,6.232,0,4.707,4.992,5.487,9.952,6.511,5,1.018,10,2.3,10,8.1,0,6.063-5.82,8.242-10.279,8.242-6.849,0-12.416-2.833-12.331-10.363h1.8c-.369,6.38,4.754,8.8,10.532,8.8,3.514,0,8.475-1.6,8.475-6.68,0-4.955-4.992-5.81-10-6.839-4.949-1.018-9.952-2.216-9.952-7.778,0-5.615,5.2-7.783,9.836-7.783,6.1,0,10.9,2.618,11.181,9.045Z",
    transform: "translate(-462.027 -559.607)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72887",
    "data-name": "Path 72887",
    d: "M567.143,578.318H579.6c3.308,0,8.511,1.187,8.511,8.184,0,5.118-3.362,8.031-9.171,8.031h-9.994v13.028h-1.8Zm1.8,14.659h10.274c5.287,0,7.1-3.483,7.1-6.512,0-2.169-.981-6.6-6.844-6.6H568.948Z",
    transform: "translate(-437 -559.042)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72888",
    "data-name": "Path 72888",
    d: "M572.507,578.318h2.252l18.48,26.827h.078V578.318h1.806v29.245H592.99l-18.6-27.033h-.078v27.033h-1.806Z",
    transform: "translate(-414.06 -559.044)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48097",
    "data-name": "Group 48097",
    transform: "translate(39.012 10.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72840",
    "data-name": "Path 72840",
    d: "M572.766,580.972a.658.658,0,0,0-.961-.255l-18.741,11.344a1.478,1.478,0,0,0-.638,1.133l0,.667c0,.581.559.811,1.054.491l19.024-11.505c.6-.391.434-1.52.258-1.875",
    transform: "translate(-530.704 -568.929)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72841",
    "data-name": "Path 72841",
    d: "M570.629,579.921a.731.731,0,0,0-.907-.1l-16.74,10.143a1.3,1.3,0,0,0-.556.993v.455a.445.445,0,0,0,.717.4l17.436-10.566c.5-.33.244-1.09.05-1.327",
    transform: "translate(-530.706 -571.245)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72842",
    "data-name": "Path 72842",
    d: "M567.636,579a.744.744,0,0,0-.8.025L552.8,587.552a.872.872,0,0,0-.377.767v.255c0,.3.219.43.48.265l14.632-8.852c.4-.208.276-.843.1-.986",
    transform: "translate(-530.711 -573.35)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72843",
    "data-name": "Path 72843",
    d: "M563.582,578.181a.771.771,0,0,0-.67.083l-10.24,6.2c-.223.129-.251.373-.251.631v.029c0,.258.179.355.4.226l10.781-6.522c.358-.158.133-.559-.018-.642",
    transform: "translate(-530.717 -575.316)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72844",
    "data-name": "Path 72844",
    d: "M557.23,577.36a1.029,1.029,0,0,0-.627.161l-3.783,2.295a.821.821,0,0,0-.4.57c0,.194.183.229.4.093l4.471-2.71c.226-.132.064-.362-.061-.409",
    transform: "translate(-530.724 -577.349)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72845",
    "data-name": "Path 72845",
    d: "M574.106,582.44c-.064-.66-.591-1.015-1.169-.635l-19.573,11.879a1.775,1.775,0,0,0-.936,1.678v.832a.74.74,0,0,0,1.19.588l20.028-12.144a1.588,1.588,0,0,0,.548-1.538Z",
    transform: "translate(-530.696 -566.231)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72846",
    "data-name": "Path 72846",
    d: "M574.392,583.752a.818.818,0,0,0-1.241-.7l-19.569,11.821a2.464,2.464,0,0,0-1.151,2l0,1.087a.924.924,0,0,0,1.29.925l19.62-11.868a2.46,2.46,0,0,0,.954-1.782s.061-1.072.093-1.477",
    transform: "translate(-530.691 -562.896)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72847",
    "data-name": "Path 72847",
    d: "M552.718,597.444c.914,1.162,2.9,3.266,5.808,3.266,2.721,0,11.646-3.406,14.518-14.883.251-1-.416-1.678-1.362-1.1-.524.312-15.557,9.408-18.7,11.316a1.138,1.138,0,0,0-.265,1.4",
    transform: "translate(-530.315 -558.826)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72848",
    "data-name": "Path 72848",
    d: "M546.938,596.784a.661.661,0,0,0,.961.262L566.636,585.7a1.472,1.472,0,0,0,.642-1.129l0-.671c0-.574-.556-.818-1.058-.495L547.2,594.912c-.6.391-.434,1.517-.262,1.872",
    transform: "translate(-545.301 -562.07)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72849",
    "data-name": "Path 72849",
    d: "M547.588,596.615a.753.753,0,0,0,.914.1l16.74-10.14a1.319,1.319,0,0,0,.552-.993v-.47a.437.437,0,0,0-.71-.387l-17.436,10.563c-.505.337-.247,1.09-.061,1.327",
    transform: "translate(-543.818 -558.531)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72850",
    "data-name": "Path 72850",
    d: "M548.378,595.964a.747.747,0,0,0,.8-.032l14.033-8.515a.875.875,0,0,0,.384-.775v-.255c0-.3-.219-.427-.477-.269l-14.643,8.859c-.395.2-.269.843-.093.986",
    transform: "translate(-541.603 -554.854)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72851",
    "data-name": "Path 72851",
    d: "M549.539,594.794a.774.774,0,0,0,.67-.083l10.24-6.185a.678.678,0,0,0,.251-.638v-.025c0-.258-.176-.359-.4-.226l-10.778,6.519c-.355.151-.133.559.018.638",
    transform: "translate(-538.706 -550.901)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72852",
    "data-name": "Path 72852",
    d: "M551.285,592.686a.99.99,0,0,0,.631-.161l3.782-2.287a.835.835,0,0,0,.4-.574c0-.183-.179-.222-.4-.086l-4.478,2.707c-.215.129-.054.362.065.4",
    transform: "translate(-534.094 -545.943)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72853",
    "data-name": "Path 72853",
    d: "M546.523,596.312c.065.663.6,1.015,1.172.645l19.573-11.9a1.753,1.753,0,0,0,.932-1.675v-.828a.738.738,0,0,0-1.19-.585L546.982,594.11a1.6,1.6,0,0,0-.545,1.542Z",
    transform: "translate(-546.238 -565.764)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72854",
    "data-name": "Path 72854",
    d: "M546.369,595.557a.815.815,0,0,0,1.233.706l19.569-11.825a2.463,2.463,0,0,0,1.155-1.994l0-1.09a.927.927,0,0,0-1.295-.928L547.409,592.29a2.505,2.505,0,0,0-.954,1.8s-.057,1.068-.086,1.47",
    transform: "translate(-546.368 -569.652)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72855",
    "data-name": "Path 72855",
    d: "M567,581.978c-.914-1.162-2.9-3.27-5.8-3.27-2.718,0-11.649,3.406-14.524,14.886-.248,1,.423,1.674,1.369,1.108.524-.319,15.554-9.415,18.691-11.323a1.126,1.126,0,0,0,.266-1.4",
    transform: "translate(-545.708 -573.836)",
    fill: "#575756"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpnGreyLogo);
export default __webpack_public_path__ + "static/media/SPN-grey-logo.cf4013900f6230a22b3faba179c9bcc2.svg";
export { ForwardRef as ReactComponent };